import React from 'react';
import { Typography } from '@mui/material';

// Cuanto stock queda de un producto si se pide la cantidad indicada. Solo lo ven los clientes
// con "ver stock" activo (Configuracion > Clientes > Productos asignados): para el resto el
// backend no envia Inv_Stock y este aviso no se pinta.
export const StockRestante = ({ stock, pedido }: { stock?: number | null; pedido: number }) => {
  if (stock === null || stock === undefined) return null;
  const restante = stock - pedido;
  return (
    <Typography variant='caption' color={restante < 0 ? 'error' : 'text.secondary'}>
      Stock disponible: {stock} · Quedarían: {restante}
      {restante < 0 && ' (la cantidad supera el stock disponible)'}
    </Typography>
  );
};

// Valor guardado por linea (PsrvD_StockRestante); en rojo si quedo negativo.
export const CeldaStockRestante = ({ valor }: { valor?: number | null }) =>
  valor === null || valor === undefined ? <>-</> : <Typography variant='body2' color={valor < 0 ? 'error' : 'inherit'}>{valor}</Typography>;
